import { defineMessages } from "react-intl";

const messages = defineMessages({
  addLocation: {
    id: "recordList.customization.sort.location.addLocation",
    defaultMessage: "Please add a location",
    description: "Address validation error",
  },
  addressLabel: {
    id: "recordList.customization.sort.location.addressLabel",
    defaultMessage: "Address",
    description: "Address label",
  },
  changeRecord: {
    id: "recordList.customization.sort.location.record.change",
    defaultMessage: "Change Record",
    description: "Change Record button title",
  },
  entityLabel: {
    id: "recordList.customization.sort.location.entityLabel",
    defaultMessage: "Company or Person",
    description: "Entity type sort label",
  },
  locationError: {
    id: "recordList.customization.sort.location.locationError",
    defaultMessage: "Unable to detect location",
    description: "Unable to detect location label",
  },
  locationErrorHelp: {
    id: "recordList.customization.sort.location.locationError.help",
    defaultMessage: "Get help",
    description: "Unable to detect location - Get help button label",
  },
  selectRecord: {
    id: "recordList.customization.sort.location.record.select",
    defaultMessage: "Select Record",
    description: "Select Record button title",
  },
  where: {
    id: "recordList.customization.sort.location.orderSelect",
    defaultMessage: "Where",
    description: "Map Customization sort direction select label for location",
  },
});

export default messages;
